import React from 'react'
import { FormattedMessage } from 'react-intl'

import styles from './styles.module.scss'

export default function CupRules({ tournament }) {
  const rulesContent = tournament?.details?.rules

  const isImportantLine = line => {
    const trimmed = line.trim()
    return /^\d+\.|^\*|^\-|^•/.test(trimmed)
  }

  const rulesLines = rulesContent?.split('\n').filter(line => line.trim()) || []

  return (
    <div className={styles.wrapper}>
      <div className={styles.infoCard}>
        <div className={styles.cardHeader}>
          <span className={styles.icon}>📋</span>
          <h2 className={styles.cardTitle}>
            <FormattedMessage id='battlecup.information.tournamentRules' />
          </h2>
        </div>
        <div className={styles.cardContent}>
          {rulesLines.length > 0 ? (
            <div className={styles.rulesContent}>
              {rulesLines.map((line, index) => (
                <p
                  key={index}
                  className={styles.rulesLine}
                  data-important={isImportantLine(line)}
                >
                  {line.trim()}
                </p>
              ))}
            </div>
          ) : (
            <div className={styles.noRules}>
              <div className={styles.noRulesIcon}>📝</div>
              <p className={styles.noRulesText}>
                <FormattedMessage id='battlecup.information.noTournamentRules' />
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
